const HONGS_HOME_PAGE = "hongs home page";
const HONGS_LOGIN_PAGE = "hongs login page";
const HONGS_SEARCH_PAGE = "hongs search page";
const HONGS_OFFERS_PAGE = "hongs offers page";
const HONGS_LOCATION_PAGE = "hongs location page";
const HONGS_PROFILE_PAGE = "hongs profile page";
const HONGS_FAVOURITE_PAGE = "hongs favourite page";
const HONGS_ORDERHISTORY_PAGE = "hongs order history page";
const HONGS_ADDRESSES_PAGE = "hongs addresses page";
const HONGS_CUSTOMISATION_PAGE = "hongs customisation page";
const HONGS_SEARCH_CUSTOMISATION_PAGE = "hongs search customisation page";
const HONGS_NON_CUSTOMISATION_PAGE = "hongs non customisation page";
const HONGS_SEARCH_NON_CUSTOMISATION_PAGE =
  "hongs search non customisation page";
const HONGS_CART_PAGE = "hongs cart page";
const HONGS_MENU_PAGE = "hongs menu page";
const HONGS_ABOUT_US_PAGE = "hongs about us page";
const HONGS_NUTRITIONAL_INFO_PAGE = "hongs nutritional info page";
const HONGS_CONTACT_US_PAGE = "hongs contact us page";
const HONGS_PRIVACY_POLICY_PAGE = "hongs privacy policy page";
const HONGS_BLOGS_PAGE = "hongs blogs page";

const getPageNameFromPathName = () => {
  const page = window.location.pathname
    ?.trim()
    ?.replace(/^\/+/, "")
    ?.replace(/\/+$/, "");

  if (page.endsWith("cart")) {
    return HONGS_CART_PAGE;
  }
  if (page.endsWith("search")) {
    return HONGS_SEARCH_PAGE;
  }
  if (page.endsWith("login")) {
    return HONGS_LOGIN_PAGE;
  }
  if (page.endsWith("offers")) {
    return HONGS_OFFERS_PAGE;
  }
  if (page.endsWith("location")) {
    return HONGS_LOCATION_PAGE;
  }
  if (page.endsWith("my-profile")) {
    return HONGS_PROFILE_PAGE;
  }
  if (page.endsWith("my-favourites")) {
    return HONGS_FAVOURITE_PAGE;
  }
  if (page.endsWith("order-history")) {
    return HONGS_ORDERHISTORY_PAGE;
  }
  if (page.endsWith("my-addresses")) {
    return HONGS_ADDRESSES_PAGE;
  }
  if (page.endsWith("menu")) {
    return HONGS_MENU_PAGE;
  }
  if (page.endsWith("about-us")) {
    return HONGS_ABOUT_US_PAGE;
  }
  if (page.endsWith("nutritional-info")) {
    return HONGS_NUTRITIONAL_INFO_PAGE;
  }
  if (page.endsWith("contact-us")) {
    return HONGS_CONTACT_US_PAGE;
  }
  if (page.endsWith("privacy-policy")) {
    return HONGS_PRIVACY_POLICY_PAGE;
  }
  if (page.includes("blog")) {
    return page.split('/blog/')[1] || HONGS_BLOGS_PAGE
  }

  return HONGS_HOME_PAGE;
};

const HOME_PAGE = "home_page";

export default {
  HONGS_HOME_PAGE,
  HONGS_LOGIN_PAGE,
  HONGS_OFFERS_PAGE,
  HONGS_SEARCH_PAGE,
  HONGS_LOCATION_PAGE,
  HONGS_CUSTOMISATION_PAGE,
  HONGS_SEARCH_CUSTOMISATION_PAGE,
  HONGS_NON_CUSTOMISATION_PAGE,
  HONGS_SEARCH_NON_CUSTOMISATION_PAGE,
  HONGS_CART_PAGE,
  HONGS_MENU_PAGE,
  HONGS_PROFILE_PAGE,
  HONGS_FAVOURITE_PAGE,
  HONGS_ORDERHISTORY_PAGE,
  HONGS_ADDRESSES_PAGE,
  HONGS_NUTRITIONAL_INFO_PAGE,
  HONGS_ABOUT_US_PAGE,
  HONGS_CONTACT_US_PAGE,
  HONGS_PRIVACY_POLICY_PAGE,
  HONGS_BLOGS_PAGE,
  getPageNameFromPathName,
  HOME_PAGE,
};
